import { defaultLanguageCountry } from '@adsk/ha-beehive-connector-util/lib/BeehiveUtils/data-helpers';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  activateLanguage,
  getLocalizedDotcomSite
} from '../../utils/languageSupport';
import { ROUTER_BASENAME } from '../../common/constants';
import { getEnvironmentConstant } from '../../common/utilities';
import BrowseByTypeComponent from './BrowseByTypeComponent';

const BrowseByType = ({ env, language, product, context }) => {
  const { productDocumentation, bannerBoxData, browseTypes } = useSelector(
    (state) => state.productData
  );

  const host = getLocalizedDotcomSite(language, env);
  const requestRouterBasename = getEnvironmentConstant({
    key: ROUTER_BASENAME,
    env
  });
  const baseUrl = `${host}${requestRouterBasename}/search`;

  let returnToContext = '';
  if (context) {
    returnToContext = `&c=${context}`;
  }

  useEffect(() => {
    activateLanguage(language);
  }, [language]);

  return (
    <I18nProvider i18n={i18n}>
      <BrowseByTypeComponent
        language={language}
        bannerBoxData={bannerBoxData}
        baseUrl={baseUrl}
        product={product}
        productDocumentation={productDocumentation}
        returnToContext={returnToContext}
        typesData={browseTypes}
      />
    </I18nProvider>
  );
};

BrowseByType.propTypes = {
  /**
   * The language selection
   */
  language: PropTypes.string,
  /**
   * The beehive environment i.e., prd or stg.
   */
  env: PropTypes.string,
  /**
   * Product Name
   */
  product: PropTypes.string,
  /**
   * Product url context to return back from.
   */
  context: PropTypes.string
};

BrowseByType.defaultProps = {
  language: defaultLanguageCountry,
  env: 'prd',
  product: '',
  context: ''
};

export default BrowseByType;
